
import { supabase } from "@/integrations/supabase/client";

export const AgentDiscoveryService = {
  async getAgentsByCategory(category: string, limit = 4): Promise<any[]> {
    try {
      const { data, error } = await supabase
        .from('agents')
        .select(`
          id,
          name,
          description,
          category,
          downloads,
          pricing_model,
          owner_id,
          profiles (
            name
          )
        `)
        .eq('category', category.toLowerCase())
        .eq('is_public', true)
        .order('downloads', { ascending: false })
        .limit(limit);

      if (error) throw error;

      return data || [];
    } catch (error) {
      console.error('Error fetching agents by category:', error);
      return [];
    }
  },
  
  async getFeaturedAgents(limit = 4): Promise<any[]> {
    try {
      const { data, error } = await supabase
        .from('agents')
        .select(`
          id,
          name,
          description,
          category,
          downloads,
          pricing_model,
          owner_id,
          profiles!fk_owner_profile (
            name
          )
        `)
        .eq('is_public', true)
        .order('downloads', { ascending: false })
        .limit(limit);

      if (error) throw error;

      // Format the data to match the expected structure
      return data.map(agent => ({
        id: agent.id,
        name: agent.name,
        description: agent.description,
        category: agent.category,
        downloads: agent.downloads || 0,
        pricing_model: agent.pricing_model,
        isPremium: agent.pricing_model !== 'free',
        rating: 4.5, // Default rating until we implement actual ratings
        author: agent.profiles?.name || 'Anonymous Creator'
      }));
    } catch (error) {
      console.error('Error fetching featured agents:', error);
      return [];
    }
  }
};
